import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store'
import axios from 'axios';
import VueMatomo from 'vue-matomo'

interface ExtendedThis {
    $matomo: {
        setCustomUrl: (path: string) => void;
        trackPageView: (title: string) => void;
    }
}

const getContextRedenen = axios.get("./contactredenen.json")
    .then(response => {
        store.dispatch('axiosSetContactredenen', response.data);
    })
    .catch(error => console.log(error));

const getLabels = axios.get(process.env.VUE_APP_LABELS_URL)
    .then(response => {
        store.dispatch('axiosLaadLabels', response.data.kinderopvang);
    })
    .catch(error => console.log(error));

Promise.allSettled([getContextRedenen, getLabels])
        .then(() => {
            const app = createApp(App)
                .use(VueMatomo, {
                    // Configure your matomo server and site
                    host: 'https://stats.duo.rijkscloud.nl/',
                    siteId: process.env.NODE_ENV === 'development' ? 4 : 1,

                    // Changes the default .js and .php endpoint's filename
                    // Default: 'matomo'
                    trackerFileName: 'piwik',

                    // Require consent before sending tracking information to matomo
                    // Default: false
                    requireConsent: false,

                    // Whether to track the initial page view
                    // Default: true
                    trackInitialView: false
                })
                .use(router)
                .use(store)
                
            app.config.globalProperties.$trackPageView = function (this: ExtendedThis, title: string) {
                if (this.$matomo) {
                    const path = window.location.href;
                    this.$matomo.setCustomUrl(path);
                    this.$matomo.trackPageView(title);
                }
            }

            app.mount('#app')
        })